exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cypher-component{background-color:transparent;border:0;outline:none;padding:0;margin:0;transition:.2s linear;filter:invert(100%);-webkit-filter:invert(100%)}.cypher-component a{display:block}.cypher-component a img{height:50px;margin:auto;display:block}.cypher-component:hover{cursor:pointer;filter:invert(40%);-webkit-filter:invert(40%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/styles/Cypher.css
// module id = 721
// module chunks = 0